<template>
  <!--
    triggered on click
    @event click
  -->
  <button
    :class="[$style.color, { [$style.selected]: selected }]"
    :style="{ '--swatch-color': color }"
    type="button"
    @click="$emit('click')"
  >
    <check-icon v-if="selected" class="icon-m" :style="{ color: 'var(--white)' }" />
  </button>
</template>

<script setup lang="ts">
import { defineComponent } from 'vue'
import { CheckIcon } from '../icons'

withDefaults(
  defineProps<{
    color: string // background color
    selected?: boolean // apply selection styles
  }>(),
  {
    selected: false,
  },
)

defineEmits<{
  click: []
}>()

defineComponent({
  name: 'UiColor',
})
</script>

<style lang="scss" module>
.color {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: var(--swatch-color, var(--white)) !important;
  box-shadow:
    0 0 0 2px var(--white),
    0 0 0 3px var(--gray-30);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.selected {
  box-shadow:
    0 0 0 2px var(--white),
    0 0 2px 4px var(--swatch-color);
}

.color:hover {
  box-shadow:
    0 0 0 2px var(--white),
    0 0 2px 4px var(--swatch-color);
}
</style>
